'use strict'

import sites from '../../../config/sites-north-america.js'

/**
 * Retrieves the root category ID for a specific brand within a site.
 *
 * @param {string} siteId - The ID of the site to search within.
 * @param {string} locale - The locale param as received with request url in browser.
 * @returns {string|null} The locale ID if found by locale alias, otherwise null.
 */
export const getLocaleID = (siteId, locale) => {
    // Find the site by ID
    const site = sites.find((site) => site.id === siteId)

    if (!site) {
        console.error(`Site with ID ${siteId} not found.`)
        return null
    }

    // Find supported locale by its alias
    const currentLocaleData = site.l10n.supportedLocales.find((supportedLocale) => supportedLocale.alias === locale)

    if (!currentLocaleData) {
        console.error(`Site ${siteId}. No locale data found  for locale alias ${locale} in sites.js configs.`)
        return null
    }

    const localeId = currentLocaleData.id;
    if (!localeId) {
        console.error(`Site ${siteId}. Locale id is not configured for locale ${locale} in sites.js configs.`)
        return null
    }

    // Return locale ID
    return localeId;
}
